import { isEmpty } from "lodash/fp";

import { WorkspaceUserInviteBody } from "@app/common/account/api";
import { get, patch, post } from "@app/common/api";
import {
  type ApiEnterpriseWorkspace,
  EnterpriseWorkspaceInviteResponse,
  UpdateWorkspaceSettingsBody,
} from "@app/common/workspaces/types";
import { snakeKeys } from "@app/utils/utils";

import * as teams from "./teams";

const getWorkspace = async (
  workspaceId: string
): Promise<ApiEnterpriseWorkspace> => {
  const workspace: ApiEnterpriseWorkspace = await get(
    `/enterprise/workspaces/${workspaceId}`,
    { withCreds: true }
  );
  // un-camelize the user integration counts since we want the keys to
  // match our known provider ids
  if (workspace.userIntegrationCounts) {
    workspace.userIntegrationCounts = snakeKeys(
      workspace.userIntegrationCounts
    );
  }
  return workspace;
};

const updateWorkspaceSettings = async (
  workspaceId: string,
  settings: UpdateWorkspaceSettingsBody
): Promise<void> => {
  return patch(
    `/enterprise/workspaces/${workspaceId}`,
    { settings },
    { withCreds: true }
  );
};

const inviteWorkspaceUsers = async (
  workspaceId: string,
  invites: WorkspaceUserInviteBody[]
): Promise<EnterpriseWorkspaceInviteResponse> => {
  if (isEmpty(invites)) return {};
  return post(`/enterprise/workspaces/${workspaceId}/bulk-invites`, invites, {
    withCreds: true,
    parseErrorResponse: true,
    // 400 status is the status we would receive if one or more invites failed. it will accompany
    // a JSON response detailing which invites succeeded and which failed, which the handler will
    // then parse out to display individual error messages to the user
    parseErrorResponseStatuses: [400],
  });
};

export default {
  getWorkspace,
  updateWorkspaceSettings,
  inviteWorkspaceUsers,
  teams,
};
